import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { StickyFiltersWrapper } from '../../../ui/atoms/CTA/style';
import { CTA, CardCourses, CustomSelect, NoResult } from '../../../ui/atoms';
import { flattenCategories } from '../../../utils/categories';
import {
  DURATION_OPTIONS,
  formatFilterOpt,
  getFilterLabel,
  getSortingOptions,
} from '../../../utils/labels';
import {
  CardsWrapper,
  CoursesContainer,
  FiltersContainer,
  SelectsContainer,
} from './style';
import { Filter } from '../CourseList/style';
import SortBy from '../../../ui/atoms/SortBy';
import Pagination from '../../../ui/atoms/Pagination';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import { MODAL_OPEN } from '../../redux/actions';
import { COMPLETED_COURSES_GET } from '../../redux/actions/dashboard';
import routes from '../../../routes';
import ModalFilters, {
  ModalFiltersId,
} from '../../../ui/atoms/Modals/ModalFilters';

const DASHBOARD_SORTING_IDS = [
  'created_desc',
  'created_asc',
  'completion_date_desc',
  'completion_date_asc',
  'alphabetical',
];

const CompletedCoursesResults = ({
  mediaIsPhone,
  active,
  data,
  categories,
  modalOpen,
  getCompletedCourses,
}) => {
  const { list, filters, pager } = data;
  const navigate = useNavigate();
  const [selectedFilters, setSelectedFilters] = useState({});

  const handleOnChange = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value;
    setSelectedFilters(newFilters);
  };

  const handleGetCourses = (page) => {
    const parsedFilters = {
      ...selectedFilters,
      categoryType: 'single_categories',
      page,
    };
    getCompletedCourses(parsedFilters);
  };

  useEffect(() => {
    handleGetCourses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  const loadMore = (page) => handleGetCourses(page);
  const setItemsPerPage = (v) =>
    handleOnChange({ key: 'items_per_page', value: v });

  return (
    <>
      {mediaIsPhone ? (
        <StickyFiltersWrapper>
          <CTA
            btnText="Filtri"
            type="secondary"
            fullsize
            onClick={() =>
              modalOpen(ModalFiltersId, {
                filters: {
                  categories: flattenCategories(categories),
                  ...filters,
                  duration: DURATION_OPTIONS,
                },
                activeFilters: selectedFilters,
                sorting: getSortingOptions(DASHBOARD_SORTING_IDS),
              })
            }
          />
        </StickyFiltersWrapper>
      ) : (
        <FiltersContainer>
          <SelectsContainer>
            {categories?.length > 0 && (
              <Filter>
                <CustomSelect
                  zIndexMenu={11}
                  placeholder="Area tematica"
                  options={flattenCategories(categories)}
                  isClearable
                  onChange={(v) =>
                    setSelectedFilters({
                      ...selectedFilters,
                      categories: v?.value,
                    })
                  }
                  selected={
                    flattenCategories(categories)?.find(
                      (s) => s.value === selectedFilters?.categories
                    ) ?? null
                  }
                />
              </Filter>
            )}
            {(Object.keys(filters) || []).map((key, i) => (
              <Filter key={`filter-${i}`}>
                <CustomSelect
                  zIndexMenu={11}
                  placeholder={getFilterLabel(key)}
                  options={filters[key].map((opt) => formatFilterOpt(opt))}
                  selected={
                    formatFilterOpt(
                      filters[key]?.find((f) => f.key === selectedFilters[key])
                    ) || null
                  }
                  onChange={(value) => handleOnChange({ key, value })}
                  isClearable
                />
              </Filter>
            ))}
            <Filter>
              <CustomSelect
                zIndexMenu={11}
                placeholder="Durata"
                options={DURATION_OPTIONS}
                isClearable
                onChange={(v) =>
                  setSelectedFilters({
                    ...selectedFilters,
                    duration: v?.value,
                  })
                }
                selected={
                  DURATION_OPTIONS.find(
                    (d) => d.value === selectedFilters?.duration
                  ) ?? null
                }
              />
            </Filter>
          </SelectsContainer>
          <SortBy
            options={getSortingOptions(DASHBOARD_SORTING_IDS)}
            onChange={(v) => {
              setSelectedFilters({
                ...selectedFilters,
                sort_by: v?.value,
              });
            }}
          />
        </FiltersContainer>
      )}
      <CoursesContainer>
        <div className="pb-5">
          {list?.length <= 0 ? (
            <NoResult />
          ) : (
            <CardsWrapper>
              {(list || []).map((item, index) => (
                <CardCourses
                  key={`course-${index}`}
                  item={item}
                  onClick={() =>
                    navigate(
                      `${routes.courseDetails.path}/${item.id}/panoramica`
                    )
                  }
                  className={mediaIsPhone ? '' : 'large'}
                  showStatus
                />
              ))}
            </CardsWrapper>
          )}
        </div>
        <Pagination
          pager={pager}
          callBack={loadMore}
          setItemsPerPage={setItemsPerPage}
        />
      </CoursesContainer>
      {mediaIsPhone && active && (
        <ModalFilters
          onClick={(newFilters) => setSelectedFilters(newFilters)}
        />
      )}
    </>
  );
};

CompletedCoursesResults.propTypes = {
  mediaIsPhone: PropTypes.bool,
  active: PropTypes.bool,
  data: PropTypes.object,
  categories: PropTypes.array,
  modalOpen: PropTypes.func,
  getCompletedCourses: PropTypes.func,
};

export default compose(
  connect(
    (state) => {
      const { categories } = state.courselist;
      const { completedCourses: data } = state.dashboard;
      return {
        categories,
        data,
      };
    },
    (dispatch) => ({
      getCompletedCourses: (filters = {}) =>
        dispatch({
          type: COMPLETED_COURSES_GET._REQUEST,
          filters: {
            ...filters,
            completion_status: 'completed',
          },
        }),
      modalOpen: (id, payload) => dispatch({ type: MODAL_OPEN, id, payload }),
    })
  ),
  withMediaQueries
)(CompletedCoursesResults);
